module.exports = __webpack_public_path__ + "img/05-min.1e6ad19e.jpg";